import type { SignalStatus } from '@latitude/signal';

// Keyed on the appStatus wire values from source/go/lib/operationappstatus.
// Every surface that renders an operation's status dot reads from this table.
const APP_STATUS_SIGNAL_STATUS: Record<string, SignalStatus> = {
  COMPLETE: 'success',

  COMPLETING: 'informational',
  GATHERING_APPROVALS: 'informational',
  GENERATING_ADDRESS: 'informational',
  PREPARING: 'informational',
  PROCESSING: 'informational',
  QUEUED: 'informational',
  SENDING: 'informational',
  SIGNING: 'informational',

  CANCELED: 'default',

  AWAITING_DEPOSIT: 'warning',
  IN_REVIEW: 'warning',
  NEEDS_APPROVAL: 'warning',
  WAITING_FOR_INITIATOR: 'warning',

  EXPIRED: 'danger',
  FAILED: 'danger',
  FAILURE_COMMITTED: 'danger',
  REJECTED: 'danger',
};

export const getAppStatusSignalStatus = (
  appStatus: string,
): SignalStatus | undefined => APP_STATUS_SIGNAL_STATUS[appStatus];
